import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { noOp } from 'constants/helper';

import { Radio } from 'uiToolkitV1/Radio';
import { Tooltip } from 'uiToolkitV1/Tooltip';

export const RealignRadioButton = ({
  rowData,
  okrUuid /* uuid of okr which is to be realigned */,
  parentUuid /* parentUuid is the uuid of parent of okr which is to be realigned */,
  selectedParentUuid /* selectedParentUuid is the uuid of okr which is selected by user to new parent */,
  setSelectedParentUuid,
}) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const isSelected = selectedParentUuid === rowData.uuid;

  const { hierarchy } = rowData;

  /* check if the current row's OKR is child of selected OKR (to disable selection of those) */
  const isChildOfOKR = hierarchy.includes(okrUuid) && hierarchy.indexOf(okrUuid) < hierarchy.indexOf(rowData.uuid);

  /* disable selection( for parent-less OKR, disable selection if current row OKR is same as selected/open OKR) */
  const isDisabled = isChildOfOKR || rowData.uuid === okrUuid;
  const disabledReason = `Can't select one of the child ${moduleName} to realign`;

  return (
    <Flex w="100%" h="100%">
      <Tooltip fontSize="14px" label={isDisabled ? disabledReason : `Select this ${moduleName}`}>
        <Flex alignItems="center">
          <Radio
            isChecked={isSelected}
            isDisabled={isDisabled}
            name={rowData.uuid}
            onClick={() => (isDisabled ? noOp() : setSelectedParentUuid(rowData.uuid))}
          />
        </Flex>
      </Tooltip>
    </Flex>
  );
};
